package com.iregained.site.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun AnimatedHeroText(
    headlines: List<String>,
    overlines: List<String> = emptyList(),
    headlineModifier: Modifier = Modifier,
    overlineModifier: Modifier = Modifier
) {
    val count = headlines.size
    var currentIndex by remember(headlines) { mutableStateOf(0) }
    var displayedHeadline by remember(headlines) { mutableStateOf(headlines.firstOrNull() ?: "") }
    var isOverlineVisible by remember { mutableStateOf(true) }
    var showCursor by remember { mutableStateOf(true) }

    // Blinking cursor loop
    LaunchedEffect(Unit) {
        while (true) {
            delay(500.milliseconds)
            showCursor = !showCursor
        }
    }

    // Unified Synchronized Animation Sequence
    LaunchedEffect(count) {
        if (count <= 1) return@LaunchedEffect

        while (true) {
            val currentHeadline = headlines[currentIndex]

            // 1. Hold Phase
            delay(3500.milliseconds)

            // 2. Delete Phase
            isOverlineVisible = false
            for (i in currentHeadline.length downTo 0) {
                displayedHeadline = currentHeadline.substring(0, i)
                delay(60.milliseconds)
            }

            delay(300.milliseconds)

            // 3. Increment Phase
            currentIndex = (currentIndex + 1) % count
            val nextHeadline = headlines[currentIndex]

            // 4. Reveal & Type Phase
            isOverlineVisible = true
            for (i in 1..nextHeadline.length) {
                displayedHeadline = nextHeadline.substring(0, i)
                delay(120.milliseconds)
            }
        }
    }

    // OPTIONAL DYNAMIC OVERLINE
    if (overlines.isNotEmpty()) {
        val safeIndex = currentIndex.coerceAtMost(overlines.lastIndex)
        SpanText(
            text = overlines[safeIndex],
            modifier = overlineModifier
                .styleModifier { property("transition", "opacity 0.8s ease-in-out, transform 0.8s ease-in-out") }
                .opacity(if (isOverlineVisible) 1 else 0)
                .translateY(if (isOverlineVisible) 0.px else (-15).px)
        )
    }

    // DYNAMIC TYPEWRITER HEADLINE
    Div(attrs = headlineModifier.toAttrs()) {
        Text(displayedHeadline)
        Span(attrs = Modifier.opacity(if (showCursor) 1 else 0).toAttrs()) {
            Text("|")
        }
    }
}